import $ from 'jquery';

export class SessionLoggedOutDetection {

  constructor(){
    //When current session is logged out, the redirect includes a '#sessionloggedout'
    //hash parameter. If not present, bail out.
    if(location.hash !== '#sessionloggedout'){
      return;
    }


    this.removeHash();

    let message = sessionLoggedOutMessage;
    this.messageTemplate = `
      <div class="ar-audience-session-restored">
        ${message}
      </div>
    `;
    this.message$ = $(this.messageTemplate);

    this.init();
  }

  init(){
    this.showMessage();
  }

  /**
   * Remove hash so URL is clean
   */
  removeHash () {
    try {
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    } catch(e){
      location.hash = '';
    }
  }

  /**
   * Show toast message to user
   */
  showMessage(){
    //Add to header on top (CSS will have it hidden off screen)
    this.message$.prependTo("header");

    //Trigger browser paint
    this.message$[0].getBoundingClientRect();

    this.message$.addClass('active');

    setTimeout(()=>{
      this.message$.removeClass('active');

      setTimeout(this.cleanUp.bind(this), 400);
    }, 4000);
  }

  cleanUp(){
    this.message$.remove();
  }
}

SessionLoggedOutDetection.initDefault = function(){
    return new SessionLoggedOutDetection();
}
